module.exports = __webpack_public_path__ + "img/ratings.c047af80.png";